import React, { useState } from 'react';
import api from '../services/api';
import './Subscription.css';
import loaderImage from '../assets/Loader.png';

const Subscription = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);

    try {
      await api.subscribeToFeatures(email);
      setEmail('');
      setIsSubmitted(true);
      // Reset the thank you message after 5 seconds
      setTimeout(() => {
        setIsSubmitted(false);
      }, 5000);
    } catch (error) {
      setError(error.message || 'Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="subscription-container">
        <div className="subscription-content">
          <div className="subscription-header">
            <span className="spinner-icon">
              <img src={loaderImage} alt="" className="loader-image" />
            </span>
            <h2 className="subscription-title">Thank You for Subscribing!</h2>
          </div>
          <p className="subscription-description">
            We'll keep you updated with the latest features and learning resources.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-container">
      <div className="subscription-content">
        <div className="subscription-header">
          <span className="spinner-icon">
            <img src={loaderImage} alt="" className="loader-image" />
          </span>
          <h2 className="subscription-title">Stay Ahead in Word Learning!</h2>
        </div>

        <p className="subscription-description">
          Exciting new features and interactive games are on the way to make learning words more fun
          and effective. Be the first to try them!
        </p>

        <div className="subscription-cta">
          <p className="subscription-subtitle">
            Sign up now to get updates and early access.
          </p>

          <form onSubmit={handleSubmit} className="subscription-form">
            <div className="form-row">
              <div className="input-wrapper">
                <input
                  type="email"
                  placeholder="example@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`subscription-input ${error ? 'error' : ''}`}
                  required
                  disabled={isSubmitting}
                />
                {error && <span className="error-message">{error}</span>}
              </div>
              <button 
                type="submit" 
                className="subscription-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Subscription; 